import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=2d77c559&scoped=true"
import script from "./ActionItems.vue?vue&type=script&lang=js"
export * from "./ActionItems.vue?vue&type=script&lang=js"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=2d77c559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77c559",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
